var refferalExpired = true;

if (document.querySelector('[data-refferal-expired]')) {
    refferalExpired = document.querySelector('[data-refferal-expired]').attributes['data-refferal-expired'].value;
}
const initCountdown = () => {
    const countdownElement = document.querySelectorAll('[data-countdown]');
    if (countdownElement.length === 0) return;

    countdownElement.forEach(element => {
        // Get the end date from the data attribute (already in PDT from Shopify)
        const endDateStr = element.dataset.countdown;
        const endDate = new Date(endDateStr);

        // Convert end date to PDT (since it's already in PDT, we just need to ensure it's treated as PDT)
        const pdtOffset = 7 * 60 * 60 * 1000; // 7 hours in milliseconds
        const endDatePDT = endDate.getTime() - pdtOffset;


        const updateCountdown = () => {
            // Get current time in local timezone
            const now = new Date();


            // Convert current time to PDT
            const nowPDT = now.getTime();

            const distance = endDatePDT - nowPDT;

            if (distance < 0) {
                element.textContent = "00 H : 00 M : 00 S";
                return;
            }

            const hours = Math.floor(distance / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            element.textContent =
                `${hours.toString().padStart(2, '0')} H : ${minutes.toString().padStart(2, '0')} M : ${seconds.toString().padStart(2, '0')} S`;
        };

        updateCountdown();
        setInterval(updateCountdown, 1000);
    });
}

document.addEventListener('DOMContentLoaded', () => {
    initCountdown();

    document.querySelectorAll('.buy__gallery').forEach((item) => {
        magna.buyCarousel(item);
    });
    // Close expiration container
    document.querySelectorAll('[data-close-expiration-container]').forEach((item) => {
        item.addEventListener('click', () => {
            document.querySelector('.expiration-container').classList.remove('active');
        });
    });

    var activeVariant = JSON.parse(document.querySelector('[data-active-variant]').innerText);
    console.log('activeVariant', activeVariant);

    const addToCartType = document.querySelector('[data-add-to-cart-type]').attributes['data-add-to-cart-type'].value
        ? document.querySelector('[data-add-to-cart-type]').attributes['data-add-to-cart-type'].value
        : 'checkout';
    let form = document.querySelector('.form'); // Select your form by class
    const cart_drawer = document.querySelector('cart-drawer');

    document.querySelectorAll('.variants input[name="id"]').forEach(function (radio) {
        radio.addEventListener('change', function () {
            if (this.checked) {
                document.dispatchEvent(
                    new CustomEvent('variantChanged', {
                        detail: { variantId: this.value },
                    })
                );
                let discount = 0;

                let variant = JSON.parse(this.dataset.json);
                let price = variant.price - discount;
                let qty = document.querySelector('[name="quantity"]:checked') ? parseInt(document.querySelector('[name="quantity"]:checked').value) : 1;
                activeVariant = variant;


                let compareAtPrice = variant.compare_at_price > price ? variant.compare_at_price : null;
                console.log('refferalExpired', refferalExpired);
                if (!refferalExpired) {
                    discount = 1900;
                    price = variant.price - discount;
                    compareAtPrice = variant.price;
                }

                form.querySelector('.buy__price--new')
                    ? (form.querySelector('.buy__price--new').innerText = `$${((price * qty) / 100).toFixed(2)}`)
                    : null;
                if (compareAtPrice) {
                    form.querySelector('.buy__price--old')
                        ? (form.querySelector('.buy__price--old').innerText = `$${((compareAtPrice * qty) / 100).toFixed(2)}`)
                        : null;
                } else {
                    form.querySelector('.buy__price--old') ? (form.querySelector('.buy__price--old').innerText = '') : null;
                }
                window.dataLayer.push({
                    event: 'variant_selected',
                    product: this.value,
                });
            }
        });
    });

    document.querySelectorAll('.variants input[name="quantity"]').forEach(function (radio) {
        radio.addEventListener('change', function () {
            if (this.checked) {
                document.dispatchEvent(
                    new CustomEvent('variantChanged', {
                        detail: { variantId: activeVariant.id },
                    })
                );
                let qty = parseInt(this.value);
                let price = activeVariant.price * qty;

                let discount = 0;

                let compareAtPrice = activeVariant.compare_at_price > price ? activeVariant.compare_at_price * qty : null;
                if (refferalExpired === 'false') {
                    discount = 1900;
                    price = price - discount;
                    compareAtPrice = price + discount;
                }

                form.querySelector('.buy__price--new')
                    ? (form.querySelector('.buy__price--new').innerText = `$${((price) / 100).toFixed(2)}`)
                    : null;
                if (compareAtPrice) {
                    form.querySelector('.buy__price--old')
                        ? (form.querySelector('.buy__price--old').innerText = `$${((compareAtPrice) / 100).toFixed(2)}`)
                        : null;
                } else {
                    form.querySelector('.buy__price--old') ? (form.querySelector('.buy__price--old').innerText = '') : null;
                }
                //   window.dataLayer.push({
                //     event: 'variant_selected',
                //     product: activeVariant.id,
                //   });
            }
        });
    });

    document.querySelectorAll('.variants input[name="quantity"]')[0].dispatchEvent(new Event('change'));

    form.addEventListener('submit', function (event) {
        event.preventDefault(); // Prevent the default form submission

        const formData = new FormData(form); // Gather form data
        if (cart_drawer) {
            formData.append(
                'sections',
                cart_drawer.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            // cart_drawer.setActiveElement(document.activeElement);
        }
        const item = {
            id: formData.get('id'),
            quantity: formData.get('quantity') ? parseInt(formData.get('quantity')) : 1,
            selling_plan: formData.get('selling_plan') ? formData.get('selling_plan') : null,
        };
        window.dataLayer.push({
            event: 'add_to_cart',
            items: [item],
        });

        // Send AJAX request to add product to cart
        fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
        })
            .then((response) => response.json())
            .then((response) => {
                if (addToCartType === 'drawer') {
                    cart_drawer.renderContents(response);
                } else {
                    window.location.href = '/checkout';
                }
            })
            .then((data) => { })
            .catch((error) => {
                console.error('Error adding product to cart:', error);
            });
    });

    const details = document.querySelectorAll('.buy__detail');
    if (details.length > 0) {
        magna.accordion('.buy__detail', true);
    }

    const modal = document.querySelector('.buy__nutrition');
    if (modal) {
        modal.addEventListener('click', magna.modal, { once: true });
    }
});


let savedLabelText = ''

document.addEventListener('DOMContentLoaded', function () {

    // 
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.type === 'childList') {
                const widget = document.querySelector('.kl_reviews__star_rating_widget')
                const summaryDiv = document.querySelector('.kl_reviews__summary__stars__count')
                if (
                    (widget && !widget.classList.contains('modified')) ||
                    (summaryDiv && !summaryDiv.classList.contains('modified'))
                ) {
                    if (widget && !widget.classList.contains('modified')) modifyWidget(widget)
                    if (summaryDiv && !summaryDiv.classList.contains('modified') && savedLabelText)
                        modifySummaryDiv(summaryDiv)
                    if (
                        (!widget || widget.classList.contains('modified')) &&
                        (!summaryDiv || summaryDiv.classList.contains('modified'))
                    ) {
                        observer.disconnect()
                    }
                }
            }
        })
    })

    observer.observe(document.body, { childList: true, subtree: true })
})

function modifyWidget(widget) {
    // Extract the rating value, remove " stars", and round to one decimal place
    const originalRating = parseFloat(
        widget.getAttribute('aria-label').split(',')[0].trim().replace(' stars', ''),
    )
    const roundedRating = Math.round(originalRating * 10) / 10
    const ratingText = roundedRating.toFixed(1)

    // Create a new element for the rating
    const ratingElement = document.createElement('span')
    ratingElement.className = 'kl-rating-value'
    ratingElement.textContent = ratingText

    // Insert the rating before the stars
    widget.insertBefore(ratingElement, widget.firstChild)

    // Change "ratings" to "reviews" and hide the original text
    const labelElement = widget.querySelector('.kl_reviews__star_rating_widget__label')
    if (labelElement) {
        const reviewsCount = labelElement.textContent.split(' ')[0]
        savedLabelText = reviewsCount + ' reviews'
        labelElement.textContent = savedLabelText
        labelElement.style.display = 'none'
    }

    // Create a new element for "reviews" text
    const reviewsElement = document.createElement('span')
    reviewsElement.className = 'kl-reviews-text'
    reviewsElement.textContent = savedLabelText
    widget.appendChild(reviewsElement)

    // Mark the widget as modified to prevent multiple modifications
    widget.classList.add('modified')
}

function modifySummaryDiv(div) {
    // Create a new label element
    const newLabel = document.createElement('span')
    newLabel.className = 'kl-summary-reviews-text'
    newLabel.textContent = savedLabelText

    // Clear the existing content and add the new label
    div.innerHTML = ''
    div.parentElement.appendChild(newLabel)

    // Mark the div as modified to prevent multiple modifications
    div.classList.add('modified')
}

// Add styles for both divs
const style = document.createElement('style')
style.textContent = `
  .kl_reviews__summary__stars__count {
    display: none;
  }
`
document.head.appendChild(style)
